import { useTranslation } from 'react-i18next';
import { ClusterSwitch } from '../internal/ClusterSwitch';

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();

    function changeLanguage( lang ) {
        i18n.changeLanguage(lang);
        localStorage.setItem('i18nextLng', lang);
        window.location.reload();
    }
    const lang = i18n.language;

    return (
        <a href="" onClick={ (event) => {event.preventDefault(); changeLanguage(lang.startsWith("en") ? "zh" : "en")}}>{lang.startsWith("en") ? "中文" : "English"}</a>
    )

}

const Header = ({brand}) => {

    let logo = '';
    switch(brand){
        case 'BRAND_TCI':
            logo = './images/TCI_Logo.png';
            break;
        case 'BRAND_VLSCH':
            logo = './images/INV_Logo.png';
            break;
        case 'BRAND_PG':
            logo = './images/PG_Logo.png';
            break;
        default:
            logo = './images/INV_Logo.png';
    }

    return (
        <header className="flex w-full items-center justify-between gap-4 bg-[#f8f9fa] px-4 py-2">
            <a href="#" className="flex shrink-0 items-center">
                <img alt="" src={logo} height="22" className="h-[22px] w-auto" />
            </a>
            <div className="flex shrink-0 items-center gap-2 text-sm text-[rgba(0,0,0,0.5)] [&_a]:text-[rgba(0,0,0,0.9)]">
                <ClusterSwitch />
                <span>|</span>
                <LanguageSwitcher />
            </div>
        </header>
    );
};

export default Header;
